<template>
  <div>
    <div class="pileDetail">
      <el-col :span="8" :lg="8" :xs="24">
        <el-image :src="image" />
      </el-col>
      <el-col :span="16" :lg="16" :xs="24">
        <div class="details">
          <div class="specifier">
            <h1>储能 50/100/150/250/500K【储能变流器】</h1>
            <h3>产品特征 Product Features</h3>
            <ul>
              <li>采用三电平设计，谐波小且效率高</li>
              <li>模块化配置，结构简单，可靠稳定，易运输、易维护</li>
              <li>专为只能电网设计，可控进行能量调度，实现有功无功调节</li>
              <li>配合STS可实现并离网无缝切换</li>
              <li>完美适配铅酸电池、锂电池、LFP，NMC、流体电池、超级电容器等多种类型电池。针对不同电池实现不同充放电策略</li>
              <li>支持IEC60870-5-104，IEC61850等多种通讯协议</li>
            </ul>
          </div>
          <div class="application">
            <h3>应用领域 Application Area</h3>
            <span>适用于发电侧、电网侧、微电网、工商业等</span>
          </div>
        </div>
      </el-col>
    </div>
    <el-divider></el-divider>
    <div class="table">
<!--      <el-table-->
<!--        :span-method="objectSpanMethod"-->
<!--        :data="tableData"-->
<!--        style="width: 95%">-->
<!--        <el-table-column-->
<!--          prop="type"-->
<!--          label="产品分类"-->
<!--          width="360px">-->
<!--        </el-table-column>-->
<!--        <el-table-column-->
<!--          prop="c30"-->
<!--          label="50K"-->
<!--          width="360px">-->
<!--        </el-table-column>-->
<!--        <el-table-column-->
<!--          prop="c60"-->
<!--          width="360px"-->
<!--          label="100K">-->
<!--        </el-table-column>-->
<!--        <el-table-column-->
<!--          prop="c90"-->
<!--          width="360px"-->
<!--          label="150K">-->
<!--        </el-table-column>-->
<!--        <el-table-column-->
<!--          prop="c120"-->
<!--          width="360px"-->
<!--          label="250K">-->
<!--        </el-table-column>-->
<!--        <el-table-column-->
<!--          prop="c500"-->
<!--          width="360px"-->
<!--          label="500K">-->
<!--        </el-table-column>-->
<!--      </el-table>-->
    </div>
  </div>
</template>

<script>
export default {
  name: "Store500kw",
  data(){
    return{
      image:require('../../../assets/images/production/barrier/储能变流器500 630KTL.jpg'),
      tableData: [
        {
          type: '直流电压范围',
          c30: '500~850V',
          c60: '500~850V',
          c90: '500~850V',
          c120: '600~900V',
          c500: '600~900V'
        },
        {
          type: '直流最大电流',
          c30: '110A',
          c60: '220A',
          c90: '330A',
          c120: '440A',
          c500:'873A'
        },
        {
          type: '交流额定电流',
          c30: '72A',
          c60: '144A',
          c90: '216A',
          c120: '360A',
          c500:'720A'
        },
        {
          type: '额定电网电压',
          c30: '400V±15%',
          c60: '400V±15%',
          c90: '400V±15%',
          c120: '400V±15%',
          c500:'400V±15%'
        },
        {
          type: '额定电网频率',
          c30: '50Hz/60Hz±2.5Hz',
          c60: '50Hz/60Hz±2.5Hz',
          c90: '50Hz/60Hz±2.5Hz',
          c120: '50Hz/60Hz±2.5Hz',
          c500:'50Hz/60Hz±2.5Hz'
        },
        {
          type: '隔离方式',
          c30: '工频隔离',
          c60: '工频隔离',
          c90: '工频隔离',
          c120: '工频隔离',
          c500:'工频隔离'
        },
        {
          type: '冷却方式',
          c30: '强制风冷',
          c60: '强制风冷',
          c90: '强制风冷',
          c120: '强制风冷',
          c500:'强制风冷'
        },
        {
          type: '防护等级',
          c30: 'IP20',
          c60: 'IP20',
          c90: 'IP20',
          c120: 'IP20',
          c500:'IP20'
        },
        {
          type: '整机尺寸',
          c30: '800*2160*800',
          c60: '800*2160*800',
          c90: '800*2160*800',
          c120: '1200*2160*800',
          c500:'2200*2160*800'
        },
        {
          type:'上位机通信方式',
          c30:'ModBus TCP/IP',
          c60:'ModBus TCP/IP',
          c90:'ModBus TCP/IP',
          c120:'ModBus TCP/IP',
          c500:'ModBus TCP/IP'
        },
        {
          type: '通信接口',
          c30: '以太网口、RS485、CAN',
          c60: '以太网口、RS485、CAN',
          c90: '以太网口、RS485、CAN',
          c120: '以太网口、RS485、CAN',
          c500: '以太网口、RS485、CAN',
        }
      ]
    }
  },
  methods:{
    objectSpanMethod({row,column,rowIndex,columnIndex}){
      //console.log(row,column,rowIndex,columnIndex)
    }
  }
}
</script>

<style lang="less" scoped>
.pileDetail{
  margin: 30px 50px;
  overflow: hidden;
  .el-image{
    float: left;
    max-height: 523.8px;
    max-width: 379.8px;
    padding: 20px 20px;
  }
  .details{
    float: left;
    margin: 20px 0;
    .specifier{
      width: 85%;
      ul{
        width: 80%;
        li{
          list-style: none;
          &:before{
            content: '';
            display: inline-block;
            width: 10px;
            height: 10px;
            background-color: #2c6bb6;
            border-radius: 50%;
            margin-right: 5px;
          }
        }
      }
    }
    .application{
      float: left;
      width: 85%;
      span{
        padding-left: 5px;
      }
    }
  }
  h1{
    padding: 0 5px;
    color: #2c6cb6;
  }
  h3{
    padding: 0 5px;
    color: #2c6cb6;
  }
}
.table{
  margin: 30px 50px;
}
</style>
